import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import {FormattedMessage} from 'react-intl';

import {Icon, Text, Heading} from '@stubhub/bamboo';
import PaymentMethods from '@stubhub/react-payment-methods';

import '../styles/index.scss';

/**
 * Component that displays the available payment methods from `methods` property in a block with a Secure Payment header.
 * With the `showHeader` property the title of payment methods block can be hidden or shown.
 */
const SecurePayment = ({className, showBorder = true, showHeader, methods}) => (
  <div
    className={cs(className, 'secure-payment-card', {
      'secure-payment-card--with-border': showBorder,
    })}
  >
    <div className="secure-payment-card__container">
      <Icon className="secure-payment-card__icon" name="Bank" />
      <div className="secure-payment-card__text">
        <div>
          <Heading tag="h4" className="secure-payment-card__text-title">
            <FormattedMessage id="secure-payment-card.title" defaultMessage="Secure payment" />
          </Heading>
        </div>

        <Text className="secure-payment-card__text-subtitle">
          <FormattedMessage
            id="secure-payment-card.subtitle"
            defaultMessage="We accept the most secure payment methods"
          />
        </Text>
        <div className="secure-payment-card__payments">
          <PaymentMethods showHeader={showHeader} methods={methods} showBorder={false} />
        </div>
      </div>
    </div>
  </div>
);

SecurePayment.propTypes = {
  /** Custom classname for the container */
  className: PropTypes.string,

  /** If border is shown */
  showBorder: PropTypes.bool,

  /** Show payments header */
  showHeader: PropTypes.bool,

  /** List of payment methods */
  methods: PropTypes.array,
};

export default SecurePayment;
